/** @format */

import { propertyMap } from 'model-mapper';
import {
  EmbeddedEquipmentKind,
  EmbededContractor,
  EmbededOrganizationalUnit,
  EmbededRealEstateStructure,
  EmbededUser,
  EquipmentTagType,
} from '../../../../../../dist/sesio-lib';

export class EquipmentRequest {
  @propertyMap({ source: '_id' })
  id: string;

  @propertyMap()
  status: 'requested' | 'refused';

  @propertyMap({ type: Date })
  statusDate: Date;

  @propertyMap()
  statusReason: Date;

  @propertyMap({ type: EmbeddedEquipmentKind })
  kind: EmbeddedEquipmentKind;

  @propertyMap({ type: EmbededOrganizationalUnit })
  organizationalUnit: EmbededOrganizationalUnit;

  @propertyMap({ type: EmbededRealEstateStructure })
  realEstateStructure: EmbededRealEstateStructure;

  @propertyMap({ type: EmbededContractor })
  contractor: EmbededContractor;

  @propertyMap()
  externalReference: string;

  @propertyMap()
  comment: string;

  @propertyMap()
  location?: string;

  @propertyMap()
  state: number;

  @propertyMap()
  tagCode: string;

  @propertyMap()
  tagType: EquipmentTagType;

  @propertyMap({ default: false })
  archived: boolean;

  @propertyMap({ type: Date })
  archivedChangedAt?: Date;

  @propertyMap({ type: EmbededUser })
  archivedChangedBy?: EmbededUser;

  @propertyMap({ type: Date })
  createdAt: Date;

  @propertyMap({ type: Date })
  updatedAt: Date;
}
